import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { EurocodeChangeRequest } from "../../domain/eurocodechangerequest";

@Component({
    selector: "app-historics",
    templateUrl: "./historics.component.html",
    styleUrls: ["./historics.component.scss"],
})
export class HistoricsComponent implements OnInit {
    selectedItem: EurocodeChangeRequest;
    @Input() data: EurocodeChangeRequest[];
    @Output() openDialog = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    openDetail(item: EurocodeChangeRequest) {
        this.selectedItem = item;
        this.openDialog.emit(this.selectedItem);
    }
}
